<template>
  <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="600">
    <template v-slot:default="dialog">
      <v-card>
        <v-toolbar color="blue" class="darken-4" dark> {{ item.id ? 'Actualizar Cafc' : 'Registrar Cafc' }} </v-toolbar>
        <v-card-text>
          <v-container class="mt-1">
            <v-select
              label="* Tipo documento sector"
              v-model="item.codigoDocumentoSector"
              :items="tdocs"
              :loading="loadingtipoDocumentoSector"
              item-value="codigo"
              dense
              outlined
            ></v-select>
            <v-text-field v-model="item.descripcion" label="* descripcion" outlined dense></v-text-field>
            <v-text-field v-model.trim="item.codigo" label="* Codigo" outlined dense></v-text-field>
            <v-text-field
              v-model.number="item.facturaNumeroInicio"
              label="* Factura Numero Inicio"
              type="number"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              v-model.number="item.facturaNumeroFin"
              label="* Factura Numero Fin"
              type="number"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              v-model="item.fecha"
              label="Fecha"
              type="date"
              pattern="\d{4}-\d{2}-\d{2}"
              outlined
              dense
            ></v-text-field>
          </v-container>

          <v-progress-linear class="mt-4" indeterminate v-if="loading" />
          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="registrar()" class="green" dark> {{ item.id ? 'Actualizar' : 'Registrar' }} </v-btn>
          <v-btn text @click="dialog.value = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        loadingtipoDocumentoSector: false,
        msg: '',
        tdocs: [
          { codigo: 1, text: '[1] COMPRA Y VENTA' },
          { codigo: 11, text: '[11] SECTOR EDUCATIVO' },
        ],
        item: {
          codigo: 'string',
          codigoDocumentoSector: 0,
          descripcion: 'string',
          estado: 0,
          facturaNumeroFin: 0,
          facturaNumeroInicio: 0,
          fecha: '',
          id: 0,
        },
      };
    },
    components: {},
    watch: {
      'item.codigoDocumentoSector': function() {
        let d = this.tdocs.find((x) => x.codigo == this.item.codigoDocumentoSector);
        if (d) this.item.descripcion = d.text;
      },
    },
    methods: {
      openmodal(item) {
        this.msg = '';
        this.dialog = true;
        this.item.id = null;
        this.item.codigo = '';
        this.item.descripcion = '';
        this.item.fecha = '';
        this.item.codigoDocumentoSector = null;
        this.item.estado = null;
        this.item.facturaNumeroFin = null;
        this.item.facturaNumeroInicio = null;
        window.console.log('>>', item);
        //this.getdocumentos();
        if (item) {
          this.item.id = item.id;
          this.item.codigo = item.codigo;
          this.item.codigoDocumentoSector = item.codigoDocumentoSector;
          this.item.descripcion = item.descripcion;
          this.item.estado = item.estado;
          this.item.facturaNumeroFin = item.facturaNumeroFin;
          this.item.facturaNumeroInicio = item.facturaNumeroInicio;
          this.item.fecha = item.fecha;
        }
      },
      getdocumentos() {
        //this.tdocs.push({codigo:1,text:""});
        let vue = this;
        this.loadingtipoDocumentoSector = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/catalogo/documentosector`,
          headers: {
            'Content-Type': 'application/json',
            apikey: this.$store.getters.getApiKey,
          },
          /*url: `${process.env.VUE_APP_API_REST}/api/v1/esam/tiposdocumentos`,
          headers: {
            'Content-Type': 'application/json',
          },*/
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            data.map((x) => {
              //x.codigo = parseInt(x.codigo_clasificador_SIN);
              x.text = `${x.codigoActividad} (${x.descripcion})`;
            });
            vue.tdocs = data;
            vue.loadingtipoDocumentoSector = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingtipoDocumentoSector = false;
          });
      },
      registrar() {
        this.msg = '';
        if (!this.item.codigoDocumentoSector) this.msg = 'Seleccione un tipo documento sector.';
        if (!this.item.descripcion) this.msg = 'Ingrese una descripcion.';
        if (!this.item.codigo) this.msg = 'Ingrese el codigo.';
        if (!this.item.facturaNumeroFin) this.msg = 'ingrese facturaNumeroFin.';
        if (!this.item.facturaNumeroInicio) this.msg = 'ingrese facturaNumeroInicio.';
        if (this.msg) return;
        let vue = this;
        vue.loading = true;
        var config = {
          method: 'post',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/cafcs`,
          headers: {
            apikey: this.$store.getters.getApiKey,
            'Content-Type': 'application/json',
          },
          data: this.item,
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            //window.console.log('registrar cafc:', data);
            if (data.id) {
              vue.msg = `Registrado, ID:${data.id}`;
              vue.$emit('newcafcregistro', data);
            }
            vue.loading = false;
            setTimeout(() => {
              vue.dialog = false;
            }, 800);
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
            let data = error.response.data;
            let mensaje = data.mensaje;
            window.console.log(data);
            if (mensaje || data.detalles) vue.msg = `Error ${mensaje}`;
            else vue.msg = `${data[0].codigo} - ${data[0].descripcion}`;
          });
      },
    },
  };
</script>
